module.exports = __webpack_public_path__ + "static/content-e6a8e8b545a4b742b871b71ec441f95b.png";